import React from 'react';
import { TopBarTypes } from '..';
import { GenericFacilityDetails } from './TopBarFacilityDetailsHelper';

export const GenericFacilityDetailsHelper = ({
  contactDetailsInfo,
  contactDetails,
  iconsList,
  redirectDetails,
  contactDetailsType,
  variantType,
}: TopBarTypes.TCommonFacilityDetails) => {
  return (
    <GenericFacilityDetails
      variant={variantType}
      facilityDetailsType={contactDetailsType}
      data={contactDetailsInfo}
      iconsList={iconsList}
      redirectDetails={redirectDetails}
      contactDetails={contactDetails}
    />
  );
};
